import { useTranslation } from "react-i18next";
import { Card, Skeleton } from "antd";

import { formatPrice, formatPriceInfo } from "../../utils/price";

import type { PriceInfo } from "../../api/subscription";

interface Props {
  finalPrice: PriceInfo | null;
  originalPrice?: PriceInfo | null;
  discountAmount: number;
  currency: string;
  nextPaymentDate: string | null;
  nextPaymentPrice: PriceInfo | null;
  loading?: boolean;
}

export const SubscriptionPriceSummary = ({
  finalPrice,
  originalPrice,
  discountAmount,
  currency,
  nextPaymentDate,
  nextPaymentPrice,
  loading = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Card
      styles={{ body: { padding: 16 } }}
      className="subscription-checkout__right-card"
    >
      <div className="subscription-checkout__total">
        <div className="subscription-checkout__total-row">
          <span>{t("subscription.total")}:</span>
          {loading ? (
            <Skeleton.Input
              active
              size="small"
              className="subscription-checkout__total-skeleton"
            />
          ) : (
            <span className="subscription-checkout__price">
              {finalPrice &&
                originalPrice &&
                originalPrice.amount > finalPrice.amount && (
                  <del className="subscription-checkout__price-old">
                    {formatPriceInfo(originalPrice)}
                  </del>
                )}
              <strong>{finalPrice && formatPriceInfo(finalPrice)}</strong>
            </span>
          )}
        </div>
        {discountAmount > 0 && (
          <div className="subscription-checkout__total-row subscription-checkout__total-row--discount">
            <span>{t("subscription.discount")}:</span>
            <span>-{formatPrice(discountAmount, currency)}</span>
          </div>
        )}
        {nextPaymentDate && nextPaymentPrice && (
          <div className="subscription-checkout__total-next">
            {t("subscription.nextPaymentDetailed")}{" "}
            {formatPriceInfo(nextPaymentPrice)}{" "}
            {t("subscription.willCharge", { date: nextPaymentDate })}
          </div>
        )}
      </div>
    </Card>
  );
};
